import axios from 'axios';

export async function getCASASTesting(casaTestingId: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/CASAS/GetCASASTesting/${casaTestingId}`,);
        return result;
    }
}

export async function saveCASASTesting(payload: any, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/CASAS/saveCASASTesting`,payload);
        return result;
    }
}


export async function searchCASASTesting(payload: any, mockMode = true) {
    const dummyResponse = {
        status: 200,
        data: {
            totalRecords: 0,
            gridData: [
                
            ],
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 2000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/CASAS/SearchCASASTesting`, payload);
        return result;
    }
}